<template>
    <v-container fluid px-3 pt-3>
        <v-layout>
            <v-flex xs12 sm10>
                <h3>Help</h3>
            </v-flex>
            <v-flex xs12 sm2 v-if="isAdmin" style="float: right; align-right;">
                <v-switch v-model="viewToggle" label="View As Admin" value="red" hide-details></v-switch>
            </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <br />
        <v-layout row wrap mx-12 v-if="isAdmin && viewToggle" class="justify-center align-center">
            <v-flex xs12 sm4>
                <v-text-field v-model="newSectionTitle" label="New Section Title"></v-text-field>
            </v-flex>
            <v-flex xs12 sm1 mx-2>
                <v-text-field v-model="newSectionSortOrder" type="number" label="Sort Order"></v-text-field>
            </v-flex>
            <v-flex xs12 sm2 mx-6>
                <v-btn :disabled="!newSectionTitle" @click="addNewSection">Add New Section</v-btn>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-progress-circular v-if="isLoading" indeterminate :size="65" :width="5"></v-progress-circular>
            <v-flex xs-12 px-4 py-2 v-if="!isLoading">
                <v-expansion-panels popout focusable>
                    <v-expansion-panel v-for="(parent, i) in parentList" :key="i">
                        <v-expansion-panel-header>
                            {{ parent.title }}
                            <div v-if="isAdmin && viewToggle" class="text-right">
                                Sort Order: {{ parent.sortOrder }}
                            </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <div v-if="isAdmin && viewToggle">
                                <br />
                            </div>
                            <v-layout row wrap mx-2 v-if="isAdmin && viewToggle" class="justify-center align-center">
                                <v-flex xs3>
                                    <v-btn
                                        rounded
                                        small
                                        @click="
                                            () => {
                                                addSubToggle = true
                                                editToggle = false
                                            }
                                        "
                                        :disabled="addSubToggle"
                                    ><v-icon>
                                        mdi-plus </v-icon
                                    >Add Sub-Section</v-btn
                                    >
                                </v-flex>
                                <v-flex xs3>
                                    <v-btn rounded small @click="editSection(parent)" :disabled="editToggle"
                                    ><v-icon>
                                        mdi-pencil </v-icon
                                    >Edit Section</v-btn
                                    >
                                </v-flex>
                                <v-flex xs3>
                                    <v-btn rounded small @click="deleteSection(parent.portalHelpContentId)"
                                    ><v-icon color="red">
                                        mdi-delete-outline </v-icon
                                    >Delete Section</v-btn
                                    >
                                </v-flex>
                            </v-layout>
                            <v-layout v-if="addSubToggle && viewToggle" row wrap class="justify-center align-center">
                                <v-flex xs12 sm4>
                                    <v-text-field
                                        v-model="newSubSectionTitle"
                                        label="New Sub-Section Title"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm1 mx-2>
                                    <v-text-field
                                        v-model="newSubSectionSortOrder"
                                        type="number"
                                        label="Sort Order"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm3>
                                    <v-btn
                                        :disabled="!newSubSectionTitle"
                                        @click="addNewSubSection(parent.portalHelpContentId)"
                                    >Add New Section</v-btn
                                    >
                                </v-flex>
                            </v-layout>
                            <v-layout v-if="editToggle && viewToggle" row wrap class="justify-center align-center">
                                <v-flex xs12 sm4>
                                    <v-text-field v-model="sectionTitle" label="Section Title"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm1 mx-2>
                                    <v-text-field
                                        v-model="sectionSortOrder"
                                        type="number"
                                        label="Sort Order"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm3>
                                    <v-btn :disabled="!sectionTitle" @click="updateSection(parent)"
                                    >Update Section</v-btn
                                    >
                                </v-flex>
                            </v-layout>
                            <br />
                            <v-expansion-panels>
                                <v-expansion-panel v-for="(child, j) in parent.children" :key="j">
                                    <v-expansion-panel-header>
                                        {{ child.title }}
                                        <div v-if="isAdmin && viewToggle" class="text-right">
                                            Sort Order: {{ child.sortOrder }}
                                        </div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <div v-if="isAdmin && viewToggle">
                                            <br />
                                        </div>
                                        <v-layout
                                            row
                                            wrap
                                            mx-2
                                            v-if="isAdmin && viewToggle"
                                            class="justify-center align-center"
                                        >
                                            <v-flex xs3>
                                                <v-btn
                                                    rounded
                                                    small
                                                    @click="editSubSection(child)"
                                                    :disabled="editSubToggle"
                                                ><v-icon>
                                                    mdi-pencil </v-icon
                                                >Edit Sub-Section</v-btn
                                                >
                                            </v-flex>
                                            <v-flex xs3>
                                                <v-btn
                                                    rounded
                                                    small
                                                    @click="saveSubSection(child, parent.portalHelpContentId)"
                                                ><v-icon color="green">
                                                    mdi-content-save-outline </v-icon
                                                >Save Help Content</v-btn
                                                >
                                            </v-flex>
                                            <v-flex xs3>
                                                <v-btn
                                                    rounded
                                                    small
                                                    @click="
                                                        deleteSubSection(
                                                            child.helpContentId,
                                                            parent.portalHelpContentId
                                                        )
                                                    "
                                                ><v-icon color="red">
                                                    mdi-delete-outline </v-icon
                                                >Delete Sub-Section</v-btn
                                                >
                                            </v-flex>
                                        </v-layout>
                                        <v-layout v-if="editSubToggle && viewToggle" row wrap class="justify-center align-center">
                                            <v-flex xs12 sm4>
                                                <v-text-field
                                                    v-model="subSectionTitle"
                                                    label="Sub-Section Title"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm1 mx-2>
                                                <v-text-field
                                                    v-model="subSectionSortOrder"
                                                    type="number"
                                                    label="Sort Order"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm3>
                                                <v-btn
                                                    :disabled="!subSectionTitle"
                                                    @click="updateSubSection(child, parent.portalHelpContentId)"
                                                >Update Sub-Section</v-btn
                                                >
                                            </v-flex>
                                        </v-layout>
                                        <br />
                                        <div v-if="!viewToggle" v-html="child.contentHtml"></div>
                                        <div v-if="viewToggle">
                                            <editor
                                                v-model="child.contentHtml"
                                                :init="tinymceConfig(child.helpContentId)"
                                                :id="child.helpContentId.toString()"
                                            ></editor>
                                        </div>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import editor from '@tinymce/tinymce-vue'
import helpService from '@/services/helpService'
import userService from '@/services/userService'
import mediaService from '@/services/mediaService'

export default {
    name: 'help',
    components: {
        editor
    },
    data: () => ({
        parentList: [],
        isLoading: false,
        newSectionTitle: null,
        newSectionSortOrder: 0,
        addSubToggle: false,
        editToggle: false,
        editSubToggle: false,
        newSubSectionTitle: null,
        newSubSectionSortOrder: 0,
        viewToggle: false,
        sectionTitle: null,
        sectionSortOrder: 0,
        subSectionTitle: null,
        subSectionSortOrder: 0,
        toggleTinymce: false,
        tinymceContent: '',
        isAdmin: userService.isAdministrator()
    }),
    mounted () {
        this.loadParentList()
    },
    methods: {
        tinymceConfig (helpContentId) {
            return {
                selector: '#editor',
                height: 1000,
                encoding: 'xml',
                plugins:
                    'print preview paste searchreplace autolink visualblocks fullscreen image link media table nonbreaking anchor lists advlist help charmap emoticons',
                menubar: 'file edit view insert format tools table help',
                toolbar:
                    'undo redo | bold italic underline strikethrough | fontfamily fontsize | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | charmap emoticons | fullscreen preview save print | image media link anchor',
                toolbar_sticky: true,
                toolbar_mode: 'sliding',
                contextmenu: 'link image table',
                content_style: 'body { background: white !important; }',
                font_family_formats:
                    'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Calibri=Calibri, Trebuchet MS, Verdana, Lucida Sans Unicode, Lucida Sans, Tahoma, Arial Unicode MS, Arial, Helvetica, sans-serif; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
                file_picker_callback: (cb, value, meta) => {
                    var input = document.createElement('input')
                    input.setAttribute('type', 'file')
                    input.onchange = () => {
                        const file = input.files[0]
                        const reader = new FileReader()
                        var formData = new FormData()
                        formData.append('file', file)
                        formData.append('parentId', helpContentId)
                        formData.append('parentType', 1)
                        mediaService.uploadFile(this.$http, formData)
                        reader.onload = () => {
                            const imageUrl = reader.result
                            const blobInfo = {
                                blobUri: imageUrl
                            }
                            cb(imageUrl, blobInfo)
                        }
                        reader.readAsDataURL(file)
                    }
                    input.click()
                }
            }
        },
        loadParentList () {
            this.parentList = []
            this.isLoading = true
            helpService.getParentList(this.$http).then(response => {
                this.loadChildLists(response.data).then(() => {
                    this.isLoading = false
                })
            })
        },
        loadChildLists (parentList) {
            return new Promise(resolve => {
                parentList.forEach(p => {
                    helpService.getChildrenByParent(this.$http, p.portalHelpContentId).then(response => {
                        p.children = response.data
                        p.children.sort((a, b) => a.sortOrder - b.sortOrder)
                        this.parentList.push(p)
                        this.parentList.sort((a, b) => a.sortOrder - b.sortOrder)
                        resolve()
                    })
                })
            })
        },
        addNewSection () {
            helpService
                .saveParent(this.$http, { title: this.newSectionTitle, sortOrder: this.newSectionSortOrder })
                .then(res => {
                    this.parentList.push(res.data)
                    this.parentList.sort((a, b) => a.sortOrder - b.sortOrder)
                    this.newSectionTitle = null
                    this.newSectionSortOrder = 0
                })
        },
        updateSection (parent) {
            parent.title = this.sectionTitle
            parent.sortOrder = this.sectionSortOrder
            helpService.saveParent(this.$http, parent).then(() => {
                this.loadParentList()
                this.sectionTitle = null
                this.sectionSortOrder = 0
            })
        },
        updateSubSection (child, parentId) {
            child.title = this.subSectionTitle
            child.sortOrder = this.subSectionSortOrder
            helpService.saveChild(this.$http, child, parentId).then(() => {
                this.loadParentList()
                this.subSectionTitle = null
                this.subSectionSortOrder = 0
            })
        },
        saveSubSection (child, parentId) {
            helpService.saveChild(this.$http, child, parentId).then(() => {
                this.loadParentList()
            })
        },
        addNewSubSection (parentId) {
            helpService
                .saveChild(
                    this.$http,
                    { title: this.newSubSectionTitle, sortOrder: this.newSubSectionSortOrder },
                    parentId
                )
                .then(res => {
                    this.parentList
                        .find(({ portalHelpContentId }) => portalHelpContentId === parentId)
                        .children.push(res.data)
                    this.parentList
                        .find(({ portalHelpContentId }) => portalHelpContentId === parentId)
                        .children.sort((a, b) => a.sortOrder - b.sortOrder)
                    this.newSubSectionTitle = null
                    this.newSubSectionSortOrder = 0
                })
        },
        deleteSection (parentId) {
            if (!confirm('You are about to delete a section and all subsections listed under. Are you sure?')) {
                return
            }
            helpService.deleteParent(this.$http, parentId).then(() => {
                this.parentList = this.parentList.filter(({ portalHelpContentId }) => portalHelpContentId !== parentId)
            })
        },
        deleteSubSection (childId, parentId) {
            if (!confirm('You are about to delete a subsection. Are you sure?')) {
                return
            }
            helpService.deleteChild(this.$http, childId).then(() => {
                this.parentList.find(
                    ({ portalHelpContentId }) => portalHelpContentId === parentId
                ).children = this.parentList
                    .find(({ portalHelpContentId }) => portalHelpContentId === parentId)
                    .children.filter(({ helpContentId }) => helpContentId !== childId)
            })
        },
        editSection (parent) {
            this.sectionTitle = parent.title
            this.sectionSortOrder = parent.sortOrder
            this.editToggle = true
            this.addSubToggle = false
        },
        editSubSection (child) {
            this.subSectionTitle = child.title
            this.subSectionSortOrder = child.sortOrder
            this.editSubToggle = true
        }
    }
}
</script>

<style></style>
